import type { ReactNode } from 'react';
import useReveal from '../hooks/useReveal';

/**
 * SectionHead — the repeated eyebrow / h2 / body block.
 *
 * Every content section (Problem, Transformation, Process, Proof) opened
 * with a near-identical header. Consolidating lets a single edit tune
 * typography or spacing everywhere.
 *
 * `title` is a ReactNode so callers can interleave the italic
 * <em className="serif"> fragment without stringly-typed HTML.
 */
interface SectionHeadProps {
  eyebrow: string;
  title: ReactNode;
  body: string;
}

export default function SectionHead({ eyebrow, title, body }: SectionHeadProps) {
  const ref = useReveal<HTMLElement>();
  return (
    <header ref={ref} className="section-head reveal">
      <p className="eyebrow">
        <span className="dot" aria-hidden="true" />
        {eyebrow}
      </p>
      <h2>{title}</h2>
      <p className="section-body">{body}</p>
    </header>
  );
}
